import React from 'react';
import { FileText } from 'lucide-react';
import SeccionPendiente from './components/SeccionPendiente';

const ComunicacionesPage = () => (
  <SeccionPendiente
    icon={FileText}
    titulo="Comunicaciones"
    descripcion="Felicitaciones, reconocimientos, llamados de atención y sanciones, con el flujo del proceso disciplinario: versión de cargos, descargos y decisión. Cada comunicado se imprime con membrete y espacio de firmas."
    entrega="Disponible en la Parte 8 del módulo"
  />
);

export default ComunicacionesPage;